import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Measurements = () => {
  const [searchParams] = useSearchParams();
  const user_id = searchParams.get('user_id');
  const { fetchWithAuth } = useAuth();
  
  const [measurements, setMeasurements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 20;

  useEffect(() => {
    fetchMeasurements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, user_id]);

  const fetchMeasurements = async () => {
    setLoading(true);
    try {
      const url = user_id 
        ? `/api/measurements?page=${page}&limit=${limit}&user_id=${user_id}`
        : `/api/measurements?page=${page}&limit=${limit}`;
      
      const response = await fetchWithAuth(url);
      if (!response.ok) throw new Error('Failed to fetch measurements');
      const data = await response.json();
      setMeasurements(data.data);
      setTotal(data.total);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const totalPages = Math.ceil(total / limit);

  if (loading && measurements.length === 0) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div>
      <h1 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '24px' }}>
        Body Measurements {user_id && `- User ${user_id}`}
      </h1>

      {user_id && (
        <div style={{ marginBottom: '16px' }}>
          <Link to="/measurements" className="link">← View All Measurements</Link>
        </div>
      )}

      <div className="card">
        <div style={{ marginBottom: '16px', color: '#666' }}>
          {total} total records
        </div>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>User</th>
                <th>Chest</th>
                <th>Waist</th>
                <th>Hips</th>
                <th>Thigh</th>
                <th>Arm</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {measurements.map((measurement) => (
                <tr key={measurement.id}>
                  <td>{measurement.id}</td>
                  <td>
                    <Link to={`/users/${measurement.user_id}`} className="link">
                      {measurement.user_name || `User ${measurement.user_id}`}
                    </Link>
                  </td>
                  <td>{measurement.chest_cm ? `${measurement.chest_cm} cm` : 'N/A'}</td>
                  <td>{measurement.waist_cm ? `${measurement.waist_cm} cm` : 'N/A'}</td>
                  <td>{measurement.hips_cm ? `${measurement.hips_cm} cm` : 'N/A'}</td>
                  <td>{measurement.thigh_cm ? `${measurement.thigh_cm} cm` : 'N/A'}</td>
                  <td>{measurement.arm_cm ? `${measurement.arm_cm} cm` : 'N/A'}</td>
                  <td>{formatDate(measurement.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {measurements.length === 0 && !loading && (
          <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
            No measurement records found
          </div>
        )}

        {totalPages > 1 && (
          <div className="pagination">
            <button
              className="btn btn-secondary"
              onClick={() => setPage(page - 1)}
              disabled={page === 1}
            >
              Previous
            </button>
            <span className="page-info">
              Page {page} of {totalPages}
            </span>
            <button
              className="btn btn-secondary"
              onClick={() => setPage(page + 1)}
              disabled={page >= totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Measurements;


